"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _NumberFormatter = require("../modules/NumberFormatter");

var HIDE_LESS_THAN = 5;
var countyReport = {
  name: 'countyReport',
  title: 'Outages by County',
  description: 'This screen provides a summary of outage information for each County.',
  linkText: 'Outages by County',
  source: function source(metadata) {
    return "./resources/data/external/interval_generation_data/".concat(metadata.directory, "/report_county.json");
  },
  initialDepth: 1,
  lastDepth: 1,
  reportFields: [{
    fieldName: 'area_name',
    label: 'County Name'
  }, {
    fieldName: 'cust_a',
    label: 'Customers Affected',
    method: function method(value) {
      return (0, _NumberFormatter.formatNumberLessThan)(value.val, HIDE_LESS_THAN);
    }
  }],
  goToAreaCriteria: function goToAreaCriteria(desc) {
    return "".concat(desc.area_name, " COUNTY IL");
  }
};
var ctvReport = {
  name: 'ctvReport',
  title: 'Outages by Cities, Towns and Villages',
  description: 'This screen provides a summary of Customers Affected by all outages by cities/towns/villages.',
  linkText: 'Outages by Cities, Towns and Villages',
  source: function source(metadata) {
    return "./resources/data/external/interval_generation_data/".concat(metadata.directory, "/report_ctv.json");
  },
  initialDepth: 1,
  lastDepth: 1,
  reportFields: [{
    fieldName: 'area_name',
    label: 'City/Town/Village Name'
  }, {
    fieldName: 'cust_a',
    label: 'Customers Affected',
    method: function method(value) {
      return (0, _NumberFormatter.formatNumberLessThan)(value.val, HIDE_LESS_THAN);
    }
  }],
  goToAreaCriteria: function goToAreaCriteria(desc) {
    return "".concat(desc.area_name, " IL");
  }
};
var wardReport = {
  name: 'wardReport',
  title: 'Outages by Chicago Wards',
  description: 'This screen provides a summary of Customers Affected by all outages by Chicago Ward.',
  linkText: 'Outages by Chicago Wards',
  source: function source(metadata) {
    return "./resources/data/external/interval_generation_data/".concat(metadata.directory, "/report_wards.json");
  },
  initialDepth: 1,
  lastDepth: 1,
  reportFields: [{
    fieldName: 'area_name',
    label: 'Chicago Ward Name'
  }, {
    fieldName: 'cust_a',
    label: 'Customers Affected',
    method: function method(value) {
      return (0, _NumberFormatter.formatNumberLessThan)(value.val, HIDE_LESS_THAN);
    }
  }],
  goToAreaCriteria: function goToAreaCriteria(desc) {
    return "".concat(desc.area_name, " CHICAGO");
  }
};
var reports = [countyReport, ctvReport, wardReport];
var _default = reports;
exports.default = _default;